export default __webpack_public_path__ + "static/media/2.455a8c6f.webp";